module.exports = __webpack_public_path__ + "static/alcacuz-quem-somos-e51979b94b0e0cabfe704337a83526bc.jpg";